import { JOB_FLOW, STATUS_META } from "@/components/StatusBadge";
import { Check } from "lucide-react";

export function StatusTimeline({ status }) {
  if (status === "CANCELLED") {
    return (
      <div className="text-sm text-[#8C867A] uppercase tracking-widest" style={{ color: "#6B7280" }}>
        Job Cancelled
      </div>
    );
  }
  const idx = JOB_FLOW.indexOf(status);
  return (
    <div className="flex flex-col gap-0" data-testid="status-timeline">
      {JOB_FLOW.map((step, i) => {
        const done = i < idx;
        const current = i === idx;
        const meta = STATUS_META[step];
        return (
          <div key={step} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 transition-all"
                style={{
                  backgroundColor: done ? meta.color : current ? `${meta.color}22` : "transparent",
                  border: `1.5px solid ${done || current ? meta.color : "#28282D"}`,
                }}
              >
                {done ? <Check size={13} color="#0D0D0E" strokeWidth={3} /> :
                  <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: current ? meta.color : "#3a3a40" }} />}
              </div>
              {i < JOB_FLOW.length - 1 && (
                <div className="w-px h-6" style={{ backgroundColor: done ? meta.color : "#28282D" }} />
              )}
            </div>
            <div className={`pb-2 pt-0.5 text-sm ${current ? "font-semibold" : ""}`}
              style={{ color: current ? meta.color : done ? "#C2BEB5" : "#5c5850" }}>
              {meta.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
